export const COMMON_ERROR_CODE = {
  COMMON_001: 'COMMON001',
  COMMON_002: 'COMMON002',
  COMMON_007: 'COMMON007',
};

const COMMON_ERROR_MESSAGE = {
  [COMMON_ERROR_CODE.COMMON_001]: '예기치 않은 서버 오류가 발생했습니다.',
  [COMMON_ERROR_CODE.COMMON_002]: '유효하지 않은 토큰입니다.',
  [COMMON_ERROR_CODE.COMMON_007]: '비활성화된 관리자입니다.',
};

export default COMMON_ERROR_MESSAGE;
